import React from 'react';
import type {NextPage} from "next";
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import TextArea from "../src/components/textArea/TextArea";
import WaveLayout from '../src/layouts/WaweLayout';
import {NavigationURLs} from "../src/functions/NavigationFunctions";
import GeneralBreadcrumb from "../src/components/breadcrumb/GeneralBreadcrumbComp";
import styled from "styled-components";
import {deviceMax} from "../styles/device";
import Colors from "../src/constants/Colors";
import Link from "next/link";

const KisiselVerilerinKorunmasi: NextPage = () => {
    const breadcrumbItems = [
        { label: 'Pembe Panjur', link: NavigationURLs.landing },
        { label: 'Kişisel Verilerin Korunması'}
    ];

    return (
        <React.Fragment>
            <HtmlHead
                pageTitle="Kişisel Verilerin Korunması | Pembe Panjur"
                description="Pembe Panjur kişisel verilerin korunması ile ilgili detaylara sayfamızdan ulaşabilirsiniz."
            />
            <WaveLayout bodyBackgroundColor={false} backgroundColor={'unset'} loginButtonText={false}
                        hamburgerMenuType={'black'} registerButton={true}>
                <ProtectionOfPersonalDataWrapper>
                    <TextArea
                        className={'mobile-plr0'}
                    >
                        <GeneralBreadcrumb items={breadcrumbItems} colorProps={false} margin={false}/>
                        <h2>
                            KİŞİSEL VERİLERİN KORUNMASI VE İŞLENMESİ HAKKINDA AYDINLATMA BİLDİRİMİ
                        </h2>
                        <h3 className={'desktop-mt-0'}>
                            Aydınlatmanın Amacı ve Veri Sorumlusu
                        </h3>
                        <p>
                            İşbu Kişisel Verilerin Korunması ve İşlenmesi Hakkında Aydınlatma Metni'nin <span
                            style={{fontWeight: 'bold'}}>
                        (Aydınlatma Metni)</span> amacı, Panjur Bilişim ve Danışmanlık Hizmetleri Ticaret A.Ş. <span
                            style={{fontWeight: 'bold'}}>(Pembe
                        Panjur)</span> tarafından elde
                            edilen kişisel verilerin işlenmesine ilişkin olarak 6698 sayılı Kişisel Verilerin Korunması
                            Hakkında Kanun'un <span style={{fontWeight: 'bold'}}>(Kanun veya KVKK)</span> 10. maddesi
                            ile
                            getirilen aydınlatma yükümlülüğünün yerine
                            getirilmesidir.
                            Kullanıcıların Pembe Panjur web sitesi ve mobil uygulaması kullanımı ile ilgili olarak Pembe
                            Panjur tarafından toplanan veya Kullanıcıların pozitif hareketleri ile kendilerinin
                            pembepanjur.com web sitesi veya Pembe Panjur mobil uygulamasına girdikleri kişisel verilerin
                            toplanma şekilleri, işlenme amaçları, hukuki sebepleri ve hakları konularında şeffaf bir
                            şekilde
                            aydınlatmaktır.
                            Pembe Panjur olarak, kişisel verilerin hukuka uygun olarak toplanması, saklanması ve
                            paylaşılmasını sağlamak ve gizliliğini korumak amacıyla mümkün olan en üst seviyede güvenlik
                            tedbirlerini almaktayız. Bu amacı gerçekleştirebilmek için kullanıcıların kişisel verileri
                            aşağıda detayları açıklanan kapsam ve koşullarda işlenmektedir.
                            Pembe Panjur, klasik bir evlilik sitesi değildir. Öncelikli amacı mutlu, uzun ve sağlıklı
                            birliktelik yaşayabilecek ciddi ilişki niyetindeki üyeleri birbirleriyle tanıştırmaktır. Bu
                            amaçla üyelerimiz arasında hem sosyo-ekonomik hem de kişilik testi sonuçlarına dayalı
                            eşleştirme
                            yapılır. Sitede sadece birbirleriyle eşleştirilmiş üyeler birbirlerini görebilir. Bu
                            faaliyetler
                            kapsamında kişisel verileriniz işbu Aydınlatma metninde belirtildiği şekilde Pembe Panjur
                            tarafından işlenmektedir. Bu bağlamda işlediğimiz kişisel verileriniz Pembe Panjur aracılığı
                            ile
                            gerçekleştirdiğiniz işlemlere göre farklılık gösterebilir. İşbu aydınlatma metni süreçlere
                            göre
                            hazırlanmış ve bu web sitesi ve mobil uygulama üzerinde gerçekleştirilebilen tüm işleme
                            faaliyetleri konusunda bilgi sahibi olmanızı amaçlamaktadır.
                            Pembe Panjur, işbu Aydınlatma hükümlerini işlediği kişisel veriler ile amaçların değişmesine
                            bağlı olarak her zaman güncelleyebilir ve değiştirebilir. Güncelleme ve değişiklikler web
                            sitesinde yayınlandığı tarihten itibaren geçerli olacaktır.
                        </p>
                        <h3 style={{marginTop: 0}}>
                            Tanımlar
                        </h3>
                        <ul>
                            <li>
                                6698 sayılı Kişisel Verilerin Korunması Kanunu'na göre:
                            </li>
                            <li>
                                Kişisel veri, kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü
                                bilgiyi;
                            </li>
                            <li>
                                Kişisel verilerin işlenmesi, kişisel verilerin tamamen veya kısmen otomatik olan ya da
                                herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla elde
                                edilmesi, kaydedilmesi, depolanması, muhafaza edilmesi, değiştirilmesi, yeniden
                                düzenlenmesi, açıklanması, aktarılması, devralınması, elde edilebilir hâle getirilmesi,
                                sınıflandırılması ya da kullanılmasının engellenmesi gibi veriler üzerinde
                                gerçekleştirilen
                                her türlü işlemi;
                            </li>
                            <li>
                                İlgili kişi, kişisel verisi işlenen gerçek kişiyi;
                            </li>
                            <li>
                                Veri sorumlusu, kişisel verilerin işleme amaçlarını ve vasıtalarını belirleyen, veri
                                kayıt
                                sisteminin kurulmasından ve yönetilmesinden sorumlu olan gerçek veya tüzel kişiyi
                            </li>
                            <li>
                                Aydınlatma yükümlülüğü, kişisel verilerin elde edilmesi sırasında veri sorumlusu veya
                                yetkilendirdiği kişinin, ilgili kişilere; veri sorumlusunun kimliği, kişisel verilerin
                                hangi
                                amaçla işleneceği, işlenen kişisel verilerin kimlere ve hangi amaçla aktarılabileceği,
                                kişisel veri toplamanın yöntemi ve hukuki sebebi ve Kanun'un 11'inci maddesinde sayılan
                                diğer hakları konusunda bilgi verme yükümlülüğünü;
                                ifade eder.
                            </li>
                            <li>
                                Sizinle ilgili kişisel veriler konusunda kişisel verilerin işleme amaçlarını ve
                                vasıtalarını
                                belirleyen, veri kayıt sisteminin kurulmasından ve yönetilmesinden sorumlu olan <span
                                style={{fontWeight: 'bold'}}>Pembe Panjur </span>
                                veri sorumlusudur.
                            </li>
                        </ul>
                        <h3 style={{marginTop: 20}}>
                            SÜREÇLERE GÖRE İŞLENEN VERİLERİNİZ
                        </h3>
                        <h4>
                            WEB SİTESİ VE MOBİL UYGULAMA
                        </h4>
                        <p className={'text-brand-color'}>
                            Web Sitemizi Ziyaret Ediyorsanız veya Mobil Uygulamamızı Kullanıyorsanız
                        </p>
                        <p style={{color: 'red'}}>
                            İşlenen Kişisel Verileriniz, İşlenme Amaçları ve Hukuki Sebepleri
                        </p>
                        <p>
                            Pembe Panjur web sitesini veya mobil uygulamasını kullanımınız sebebiyle tarafınıza ait bazı
                            kişisel verileri elde ederiz. Bu kapsamda;
                        </p>
                        <p>
                            <span style={{fontWeight: 'bold'}}>Web Sitesi Trafik Bilgileriniz, </span> İşlem Güvenliği
                            (Bağlantı Zamanı, Ziyaret Edilen Sayfa, IP
                            Adresi gibi)
                        </p>
                        <p>
                        <span style={{fontWeight: 'bold'}}>
                            Faaliyetlerin Mevzuata Uygun Yürütülmesi, Ziyaretçi Kayıtlarının Oluşturulması ve Takibi, Bilgi
                            Güvenliği Süreçlerinin Yürütülmesi ile Saklama ve arşiv faaliyetlerinin yürütülmesi amaçlarıyla
                        </span>
                        </p>
                        <ul>
                            <li>
                            <span style={{fontWeight: 'bold'}}>
                                KVKK 5/2a’da belirtilen Kanunlarda Açıkça Öngörülmesi Sebebiyle
                            </span>
                            </li>
                            <li>
                                5651 Sayılı İnternet Ortamında Yapılan Yayınların Düzenlenmesi ve Bu Yayınlar Yoluyla
                                İşlenen Suçlarla Mücadele Edilmesi Hakkında Kanun'daki Yer Sağlayıcının Sorumluluğu’na
                                (Madde 4’e) istinaden işlenmektedir.
                            </li>
                        </ul>
                        <p>
                            Bunların yanında çerezler vasıtasıyla işlenen kişisel verileriniz ile ilgili bilgilendirmeye
                            <a href={NavigationURLs.policy}
                               style={{color: '#000', textDecoration: 'underline'}}> Çerezlerle
                                İşlenen Kişisel Veriler Hakkında Aydınlatma
                                Metni’nden (Çerez Aydınlatması) </a> erişebilirsiniz.
                        </p>
                        <p>
                        <span
                            style={{fontWeight: 'bold'}}>Pembe Panjur mobil uygulamasını kullanımınız halinde </span> yukarıdakilerden
                            farklı olarak İşlem
                            Güvenliği (Mobil cihaz bilgileri, Arıza ve performans tanıları) bilgileriniz
                        </p>
                        <p>
                            <span style={{fontWeight: 'bold'}}>Bilgi Güvenliği Süreçlerinin Yürütülmesi amacıyla</span>
                        </p>
                        <ul>
                            <li style={{fontWeight: 'bold'}}>
                                KVKK Md.5/2f'deki ilgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla
                                veri
                                sorumlusunun meşru menfaatleri için veri işlemenin zorunlu olması sebebiyle
                                işlenmektedir.
                            </li>
                        </ul>
                        <p style={{color: 'red'}}>
                            Kişisel Verilerinizin Aktarılması
                        </p>
                        <p>
                            Kişisel verileriniz KVKK Md.28/1 çerçevesinde talep edilmesi halinde aydınlatma yükümlülüğü
                            olmadan ve açık rızanız aranmadan ilgili makamlara aktarılabilir.
                        </p>
                        <p>
                            Bunun dışında öngörülemeyen durumlarda da kişisel verileriniz kanunlarda açıkça belirtilmiş
                            durumlarda talep edilmesi halinde kanunlarda belirtilen kamu kurumlarına (Bakanlıklar gibi
                            idari
                            makamlara) kanunda öngörülen amaç ve sınırlamalar dahilinde aktarılabilir.
                        </p>
                        <p>
                            Aydınlatma yükümlülüğü olmayan ve açık rızanızı gerektirmeyen yasal yükümlülüklerimizin
                            dışında;
                            üçüncü parti çerez sağlayıcılara, çerezler vasıtası ile işlenen web sitesindeki
                            hareketleriniz,
                            seçimleriniz ve tercihlerinize ilişkin bazı bilgiler aktarılabilir. Ayrıntılı bilgi için
                            <a href={NavigationURLs.policy} style={{color: '#000', textDecoration: 'underline'}}> Çerez
                                Aydınlatması</a>’nı inceleyebilirsiniz.
                        </p>
                        <h4>
                            ÜYELİK SÜREÇLERİ
                        </h4>
                        <p className={'text-brand-color'}>
                            Üye Oluyorsanız
                        </p>
                        <p style={{color: 'red'}}>
                            Kişisel Verilerinizin İşlenme Amaçları ve Hukuki Sebepleri
                        </p>
                        <p>
                            Pembe Panjur’un hizmetlerinden faydalanabilmek için üye olmanız gerekmektedir. Üye olmak
                            istemeniz halinde kişisel verileriniz işlenir. Bu bağlamda üyelik sırasında ve daha sonra
                            yaptığınız işlemler sırasında işlenen;
                        </p>
                        <p>
                            <span style={{fontWeight: 'bold'}}>Üyelik bilgilerinizi oluşturan, </span> Kimlik (Ad,
                            Soyad,
                            Doğum Tarihi, Cinsiyet, Medeni Hal), Finans
                            (Aylık Yaklaşık Gelir, Ev Sahipliği Gösterme Tercihi), İletişim (Telefon Numarası, E-posta,
                            İlçe, Şehir, Ülke), Öğrenim Bilgileri (Öğrenim Durumuna İlişkin Açıklama), İşlem Güvenliği
                            (IP
                            Adresi, Üye Id, İşlem Tarihi, Şifre / Parola, Üyelik Tarihi), Mesleki Deneyim (Çalışma
                            Durumu,
                            Meslek Adı, Bilinen Yabancı Diller, Mezun olunan okul, Öğrencilik Durumu, vd.), Eş Adayı
                            Beklentileri (Çocuk Sahibi Olma Tercihi, Çocuk sayısı, Aday Tercihi, Adayın çocuğunun
                            olmasını
                            tercih etme, Adayın çocuğuyla yaşamasını tercih etme, vd.), Fiziksel Görünüm (Boy, Göz
                            rengi,
                            Kilo, Saç Rengi, Dış Görünüm), Yaşam Tarzı (Birlikte Yaşanılan Kişi, Hobiler, Kendisini
                            Anlatım
                            vd), Lokasyon (Mesafe Tercihi) kişisel verileriniz;
                        </p>
                        <ul>
                            <li>
                                Bilgi güvenliği, hizmet satış, operasyon, müşteri ilişkileri yönetimi, sözleşme ve
                                saklama
                                süreçlerinin yürütülmesi amaçlarıyla
                            </li>
                            <li>
                                KVKK Md.5/2c'de düzenlenen bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                                ilgili
                                olması kaydıyla, sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli
                                olması
                                sebebiyle
                            </li>
                            <li>
                                Sizinle akdedilen/akdedilecek olan Üyelik Sözleşmesine istinaden işlenip üyelik
                                süresince
                                saklanır.
                            </li>
                            <p>Ayrıca Kişilik Testine verdiğiniz cevaplar ile bunların sonucunda ortaya çıkan
                                <span style={{fontWeight: 'bold'}}> kişilik bilgileriniz,</span>
                            </p>
                            <li>
                                Üyelik faaliyetlerinin yürütülmesi, hizmet operasyon süreçlerinin yürütülmesi, size en
                                uygun
                                adayın tespit edilebilmesi ve saklama süreçlerinin yürütülmesi amaçlarıyla
                            </li>
                            <li>
                                Kanun’un 6/2 maddesinde düzenlenen özel nitelikli kişisel verilerinizin işlenmesine
                                ilişkin
                                açık rızanızın bulunması durumunda üyeliğiniz süresince işlenir.
                            </li>
                        </ul>
                        <p style={{color: 'red'}}>
                            Kişisel Verilerinizin Aktarılması
                        </p>
                        <p>
                            Kişisel verileriniz KVKK Md.28/1 çerçevesinde talep edilmesi halinde aydınlatma yükümlülüğü
                            olmadan ve açık rızanız aranmadan ilgili makamlara aktarılabilir.
                        </p>
                        <p>
                            Bunun dışında öngörülemeyen durumlarda da kişisel verileriniz kanunlarda açıkça belirtilmiş
                            durumlarda talep edilmesi halinde kanunlarda belirtilen kamu kurumlarına (Bakanlıklar gibi
                            idari
                            makamlara) kanunda öngörülen amaç ve sınırlamalar dahilinde aktarılabilir.
                        </p>
                        <p>
                            Üyelik bilgilerinizin bir kısmı üyelik sonrasında, sizin seçtiğiniz üye grubu ile üyelik
                            faaliyetlerinin yürütülebilmesi ve uygulamanın amacına uygun olarak çalışabilmesi için KVKK
                            Md.5/2d'deki ilgili kişinin kendisi tarafından alenileştirilmiş olması sebebiyle paylaşılır.
                        </p>
                        <p className={'text-brand-color'}>
                            Etkileşim Süreçleri
                        </p>
                        <p style={{color: 'red'}}>
                            Kişisel Verilerinizin İşlenme Amaçları ve Hukuki Sebepleri
                        </p>
                        <p>
                            Pembe Panjur’u kullanımınız sırasında gerçekleştirdiğiniz işlemlere ilişkin bilgiler
                            işlenir. Bu
                            bilgiler kullanım amacınıza uygun şekilde Pembe Panjur’u kullanabilmeniz amacıyla işlenir.
                            Bu
                            kapsamda;
                        </p>
                        <p>
                            <span style={{fontWeight: 'bold'}}>Üyelik faaliyetlerinize ilişkin; Müşteri İşlem </span>(Adayla
                            Uyum Oranları, Görünürlük Tercihi,
                            Engellendiği üye, Favori olarak seçilen üye, Favorisi olduğu üye, Göz kırpan üye, Göz
                            kırpılan
                            üye, İlgilenilmeyen üye, Kayıtlı arama kriterleri, vd.), <span style={{fontWeight: 'bold'}}>İşlem Güvenliği</span> (Son
                            giriş zamanı)
                            kişisel verileriniz,
                        </p>
                        <ul>
                            <li>
                                Üyelik faaliyetlerin yürütülebilmesi ve denetlenmesi, hizmet üretim ve operasyon
                                süreçlerinin yürütülmesi, müşteri ilişkileri yönetimi, saklama ve iletişim
                                faaliyetlerinin
                                yürütülmesi amaçlarıyla
                            </li>
                            <li>
                                KVKK Md.5/2c'de düzenlenen bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                                ilgili
                                olması kaydıyla, sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli
                                olması
                                sebebiyle
                            </li>
                            <li>
                                Sizinle akdedilen/akdedilecek olan Üyelik Sözleşmesine istinaden işlenip üyelik
                                süresince
                                saklanır.
                            </li>
                            <li>
                                Ayrıca bu bilgileriniz bilgi güvenliği süreçlerinin yürütülmesi saklama ve müşteri
                                memnuniyeti amaçlarıyla
                            </li>
                            <li>
                                KVKK Md.5/2f'deki ilgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla
                                veri
                                sorumlusunun meşru menfaatleri için veri işlemenin zorunlu olması sebebiyle işlenir ve
                                saklanır.
                            </li>
                        </ul>
                        <p>
                        <span
                            style={{fontWeight: 'bold'}}>Talep ve şikayetlerinize ilişkin; Müşteri İşlem </span> (Engellendiği
                            üye, İlgilenilmeyen üye, Mesaj,
                            Şikayet ettiği üye, Yapılan geri bildirim ve yorum) kişisel verileriniz
                        </p>
                        <ul>
                            <li>
                                Talep ve şikayetlerin takibi amacıyla
                            </li>
                            <li>
                                KVKK Md.5/2f'deki ilgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla
                                veri
                                sorumlusunun meşru menfaatleri için veri işlemenin zorunlu olması sebebiyle
                            </li>
                        </ul>
                        <p>
                            Pembe Panjur üzerinde üyelere açık sosyal paylaşımlar yapabilir, uygunluk durumunuzu
                            gösterebilirsiniz. <span
                            style={{fontWeight: 'bold'}}>Gerçekleştirdiğiniz paylaşımlar </span> kapsamında
                            işlenen; <span
                            style={{fontWeight: 'bold'}}>Müşteri
                        İşlem</span> (Uygun üye,
                            Yapılan paylaşım), <span style={{fontWeight: 'bold'}}>İşlem Güvenliği</span> (Son giriş
                            zamanı)
                            kişisel verileriniz,
                        </p>
                        <ul>
                            <li>
                                Üyelik faaliyetlerin yürütülebilmesi amacıyla
                            </li>
                            <li>
                                KVKK Md.5/2d'deki llgili kişinin kendisi tarafından alenileştirilmiş olması sebebiyle
                                işlenmekte ve diğer üyelere açık olarak yayınlanmaktadır.
                            </li>
                        </ul>
                        <p style={{color: 'red'}}>
                            Kişisel Verilerinizin Aktarılması
                        </p>
                        <p>
                            Kişisel verileriniz KVKK Md.28/1 çerçevesinde talep edilmesi halinde aydınlatma yükümlülüğü
                            olmadan ve açık rızanız aranmadan ilgili makamlara aktarılabilir.
                        </p>
                        <p>
                            Bunun dışında öngörülemeyen durumlarda da kişisel verileriniz kanunlarda açıkça belirtilmiş
                            durumlarda talep edilmesi halinde kanunlarda belirtilen kamu kurumlarına (Bakanlıklar gibi
                            idari
                            makamlara) kanunda öngörülen amaç ve sınırlamalar dahilinde aktarılabilir.
                        </p>
                        <p>
                            Üyelik bilgilerinizin bir kısmı üyelik sonrasında, sizin seçtiğiniz üye grubu ile üyelik
                            faaliyetlerinin yürütülebilmesi ve uygulamanın amacına uygun olarak çalışabilmesi için KVKK
                            Md.5/2d'deki ilgili kişinin kendisi tarafından alenileştirilmiş olması sebebiyle paylaşılır.
                        </p>
                        <h4>
                            GOLD ÜYELİK
                        </h4>
                        <p>
                            Pembe Panjur’a üye olmak ücretsizdir. Profili onaylanan her üye standart üye haklarına sahip
                            olur. Bu haklar; ücretsiz profil oluşturmak, profiline fotoğraf eklemek, bilimsel karakter
                            analiz testinden faydalanmak, diğer üyelerin profillerini görüntülemek ve favori seçmekten
                            oluşmaktadır. Diğer üyelerle iletişim kurmak, mesaj ve göz kırpma göndermek, durum
                            güncellemesi
                            paylaşmak, sohbet uygulamasından faydalanmak isterseniz Gold üye olmanız gerekir.
                        </p>

                        <p className={'text-brand-color'}>Gold Üyelik Süreçleri</p>
                        <p style={{color: 'red'}}>Kişisel Verilerinizin İşlenme Amaçları ve Hukuki Sebepleri</p>
                        <p>
                            <span
                                style={{fontWeight: 'bold'}}>Gold üyelik kapsamında işlenen; Müşteri İşlem</span> (Gold
                            Paket Seçimi, Ödeme Yöntemi), <span style={{fontWeight: 'bold'}}>İşlem Güvenliği</span> (Üye
                            Id,
                            İşlem Tarihi), <span style={{fontWeight: 'bold'}}>Finans</span> (Ödenecek Tutar),
                            <span style={{fontWeight: 'bold'}}>Hukuki İşlem</span> (Mesafeli Sözleşme Onayı) kişisel
                            verileriniz;
                        </p>
                        <ul>
                            <li>
                                Mal/Hizmet satış süreçlerinin, sözleşme süreçlerinin, finans ve muhasebe işlerinin
                                süreçlerinin yürütülmesi amaçlarıyla.
                            </li>
                            <li>
                                KVKK Md. 5/2c'de düzenlenen bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                                ilgili
                                olması kaydıyla, sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli
                                olması
                                sebebiyle.
                            </li>
                            <li>
                                Sizinle akdedilecek olan Gold Üyelik Mesafeli Satış Sözleşmesine istinaden
                                işlenmektedir.
                            </li>
                        </ul>
                        <p>
                            Mesafeli sözleşmeniz ve ön bilgilendirme formuna ilişkin bilgileriniz mal/hizmet satış
                            süreçlerinin yürütülmesi amacıyla KVKK Md. 5/2ç’deki veri sorumlusunun hukuki yükümlüğünü
                            yerine
                            getirmesi için zorunlu olması sebebiyle Mesafeli Sözleşmeler Yönetmeliğindeki kalıcı veri
                            saklayıcısı ile bildirim yükümlülüğüne (Madde 6) istinaden işlenmekte ve tarafınıza
                            iletilmektedir.
                        </p>

                        <p className={'text-brand-color'}>Ödeme Süreçleri</p>
                        <p style={{color: 'red'}}>Kişisel Verilerinizin İşlenme Amaçları ve Hukuki Sebepleri</p>

                        <p>
                            <span style={{fontWeight: 'bold'}}>Kredi Kartı ile Ödeme:</span> Pembe Panjur üzerinde
                            gerçekleştirdiğiniz ödeme işlemi için girdiğiniz
                            kredi kartı bilgilerinizi içeren <span style={{fontWeight: 'bold'}}>Kimlik</span> (Ad,
                            Soyad),
                            <span style={{fontWeight: 'bold'}}>Finans</span> (Kredi Kart Numarası, Kredi Kartı
                            Son Kullanım Tarihi, Kredi Kartı Güvenlik Numarası, Ödeme Şekli), <span
                            style={{fontWeight: 'bold'}}>Müşteri İşlem</span> (Ücret, İşlem
                            Açıklaması, İşlem Zamanı, İşlem Numarası, Onay Numarası) kişisel verileriniz;
                        </p>
                        <ul>
                            <li>Mal/Hizmet satış ile finans ve muhasebe süreçlerinin yürütülmesi amacıyla.</li>
                            <li>KVKK Md. 5/2c'de düzenlenen bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                                ilgili
                                olması kaydıyla, sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli
                                olması
                                sebebiyle.
                            </li>
                            <li>Sizinle akdedilen Gold Üyelik Mesafeli Satış Sözleşmesine istinaden işlenmekte, akabinde
                                ilgili ödeme kuruluşu ve banka ile paylaşılmaktadır.
                            </li>
                        </ul>

                        <p>
                            <span style={{fontWeight: 'bold'}}>Havale/EFT ile Ödeme:</span> Ödemenizi havale/EFT yoluyla
                            gerçekleştiriyorsanız, <span style={{fontWeight: 'bold'}}>Kimlik</span> (Ad, Soyad),
                            <span style={{fontWeight: 'bold'}}>İletişim</span> (E-Posta Adresi, Açıklama Notu), <span
                            style={{fontWeight: 'bold'}}>Finans</span> (İşlem Tutarı, Gönderim Tarihi, Banka Adı),
                            <span style={{fontWeight: 'bold'}}>Müşteri İşlem</span> (Üye Numarası ) kişisel verileriniz;
                        </p>
                        <ul>
                            <li>Mal/Hizmet satış ile finans ve muhasebe süreçlerinin yürütülmesi amacıyla.</li>
                            <li>KVKK Md. 5/2c'de düzenlenen bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                                ilgili
                                olması kaydıyla, sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli
                                olması
                                sebebiyle.
                            </li>
                            <li>Sizinle akdedilen Gold Üyelik Mesafeli Satış Sözleşmesine istinaden işlenmekte ve ilgili
                                bankalarla paylaşılmaktadır.
                            </li>
                        </ul>

                        <p>
                            <span style={{fontWeight: 'bold'}}>Mobil Ödeme:</span> Ödemenizi mobil ödeme yoluyla
                            gerçekleştiriyorsanız, <span style={{fontWeight: 'bold'}}>İletişim</span> (Telefon Numarası,
                            Telefon Operatör), <span style={{fontWeight: 'bold'}}>Müşteri İşlem</span> (Ödeme Miktarı,
                            Ödemenin Gerçekleşip Gerçekleşmediği) kişisel
                            verileriniz;
                        </p>
                        <ul>
                            <li>Mal/Hizmet satış, sözleşme ve finans ve muhasebe süreçlerinin yürütülmesi amacıyla.</li>
                            <li>KVKK Md. 5/2c'de düzenlenen bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                                ilgili
                                olması kaydıyla, sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli
                                olması
                                sebebiyle.
                            </li>
                            <li>Sizinle akdedilen Gold Üyelik Mesafeli Satış Sözleşmesine istinaden işlenmekte ve ilgili
                                mobil ödeme operatörleriyle paylaşılmaktadır.
                            </li>
                        </ul>

                        <p style={{color: 'red'}}>Kişisel Verilerinizin Aktarılması</p>
                        <p>
                            Kişisel verileriniz Kanun’un 28. maddesinde belirtilen istisna hükümleri kapsamında
                            aydınlatma
                            yükümlülüğü olmaksızın ilgili makamlara aktarılabilir. Bunun dışında öngörülemeyen ve
                            kanunlarda
                            açıkça belirtilen hallerde, belirtilen idari kurumlara, öngörülen amaç ve sınırlamalar
                            dâhilinde
                            aktarılabilir.
                        </p>
                        <p>
                            Kanun’un istisnaları ile aydınlatma yükümlülüğümüz kapsamında olmayan haller dışında,
                            kişisel
                            verileriniz aşağıda belirtilen amaçlarla belirtilen kişi, kurum veya kuruluşlara
                            aktarılabilir:
                        </p>
                        <ul>
                            <li>
                                Kredi kartı bilgileriniz ile ödemeye ilişkin kişisel verileriniz ödemenin alınabilmesi
                                amacıyla ödeme hizmet sağlayıcı tedarikçilerimiz ve bankaya aktarılmaktadır.
                            </li>
                            <li>
                                Ödemenizi havale/EFT yoluyla gerçekleştiriyorsanız, ödemeniz ile ilgili bilgiler,
                                ödemenin
                                alınabilmesi amacıyla zorunlu olarak banka ile paylaşılmaktadır.
                            </li>
                            <li>
                                Ödemenizi mobil ödeme yoluyla gerçekleştiriyorsanız, ödemeniz ile ilgili bilgiler,
                                ödemenin
                                alınabilmesi amacıyla zorunlu olarak mobil ödeme operatörleriyle ile paylaşılmaktadır.
                            </li>
                        </ul>

                        <p className={'text-brand-color'}>Faturalandırma Süreçleri</p>
                        <p style={{color: 'red'}}>Kişisel Verilerinizin İşlenme Amaçları ve Hukuki Sebepleri</p>

                        <p>
                            <span style={{fontWeight: 'bold'}}>Fatura Düzenlenmesi:</span> Satın aldığınız ürün veya
                            hizmetler sebebiyle tarafınıza fatura
                            düzenlenmektedir. Bu kapsamda faturaya ilişkin; <span
                            style={{fontWeight: 'bold'}}>Kimlik</span> (Ad, Soyad ve T.C. Kimlik No), <span
                            style={{fontWeight: 'bold'}}>İletişim</span>
                            (Adres ) <span style={{fontWeight: 'bold'}}>Finans</span> (Vergi Dairesi ve Vergi Kimlik No)
                            <span style={{fontWeight: 'bold'}}>Müşteri İşlem</span> (Satılan Ürün / Hizmet, Tutar,
                            Fatura No, vd) kişisel verileriniz;
                        </p>
                        <ul>
                            <li>Mal/Hizmet satış ile finans ve muhasebe süreçlerinin yürütülmesi amacıyla.</li>
                            <li>KVKK Md.5/2ç'deki veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi için
                                zorunlu
                                olması sebebiyle.
                            </li>
                            <li>Vergi Usul Kanunu (kanun No: 213)'ndaki Fatura Ve İrsaliye Düzenleme Zorunluluğu'na (Md.
                                230/1 5. bent ve Md. 232/1) istinaden işlenmekte.
                            </li>
                            <li>Yetkili kişi, kurum ve kuruluşlara bilgi verilmesi amacıyla.</li>
                            <li>KVKK Md.5/2ç'deki veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi için
                                zorunlu
                                olması sebebiyle.
                            </li>
                            <li>Vergi Usul Kanunu Genel Tebliği (sıra No: 433)'ndaki E-arşiv Fatura Düzenleme
                                Zorunluluğu'na
                                (Madde 3/b) istinaden E-fatura entegratör firma ve GİB ile paylaşılmaktadır.
                            </li>
                        </ul>

                        <p style={{color: 'red'}}>Kişisel Verilerinizin Aktarılması</p>
                        <p>
                            Kişisel verileriniz Kanun’un 28. maddesinde belirtilen istisna hükümleri kapsamında
                            aydınlatma
                            yükümlülüğü olmaksızın ilgili makamlara aktarılabilir. Bunun dışında öngörülemeyen ve
                            kanunlarda
                            açıkça belirtilen hallerde, belirtilen idari kurumlara, öngörülen amaç ve sınırlamalar
                            dâhilinde
                            aktarılabilir.
                        </p>
                        <p>
                            Kanun’un istisnaları ile aydınlatma yükümlülüğümüz kapsamında olmayan haller dışında, Fatura
                            bilgileriniz mevzuat gereği yetkili kurumlara bilgi verilmesi gerektiğinden entegratör firma
                            aracılığı ile T.C. Gelir İdaresi Başkanlığı’na aktarılmaktadır.
                        </p>

                        <p className={'text-brand-color'}>İşlem ve Elektronik Kayıtları Saklama Süreçleri</p>
                        <p style={{color: 'red'}}>Kişisel Verilerinizin İşlenme Amaçları ve Hukuki Sebepleri</p>
                        <p>
                            Pembe Panjur web sitesi ve mobil uygulaması üzerinde gerçekleştirdiğiniz işlemlerin log (iz)
                            kayıtları, bilgi güvenliği süreçlerinin yürütülmesi ve saklama amaçlarıyla KVKK Md.5/2f'deki
                            ilgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla veri sorumlusunun meşru
                            menfaatleri için veri işlemenin zorunlu olması sebebiyle işlenmektedir.
                        </p>
                        <p>
                            Pembe Panjur üzerinde gerçekleştirdiğiniz elektronik ticaret işlemine ilişkin işbu
                            aydınlatma
                            metninde açıklanan kişisel verileriniz:
                        </p>
                        <ul>
                            <li>Saklama ve arşiv faaliyetlerinin yürütülmesi amacıyla.</li>
                            <li style={{fontWeight: 'bold'}}>KVKK Md.5/2ç’deki veri sorumlusunun hukuki yükümlülüğünü
                                yerine
                                getirmesi için zorunlu
                                olması sebebiyle.
                            </li>
                            <li>Elektronik Ticarette Hizmet Sağlayıcılar İle Aracı Hizmet Sağlayıcılar Hakkında
                                Yönetmelik'deki Elektronik Kayıtları Saklanma Yükümlülüğü'ne (Madde 11/2) istinaden
                                saklanmaktadır.
                            </li>
                        </ul>
                        <p>
                            Pembe Panjur üzerinden satın aldığınız hizmetler ile onayladığınız dokümanlara ilişkin
                            kayıtlar,
                            saklama ve arşiv faaliyetlerinin yürütülmesi amacıyla ve KVKK Md.5/2e'deki bir hakkın
                            tesisi,
                            kullanılması veya korunması için veri işlemenin zorunlu olması sebebiyle saklanmaktadır.
                        </p>

                        <p style={{color: 'red'}}>Kişisel Verilerinizin Aktarılması</p>
                        <p>
                            Kişisel verileriniz Kanun’un 28. maddesinde belirtilen istisna hükümleri kapsamında
                            aydınlatma
                            yükümlülüğü olmaksızın ilgili makamlara aktarılabilir. Bunun dışında öngörülemeyen ve
                            kanunlarda
                            açıkça belirtilen hallerde, belirtilen idari kurumlara, öngörülen amaç ve sınırlamalar
                            dâhilinde
                            aktarılabilir.
                        </p>
                        <p>
                            Kanun’un istisnaları ile aydınlatma yükümlülüğümüz kapsamında olmayan haller dışında,
                            kişisel
                            verileriniz, güvenli şekilde barındırılması ve yedeklenmesi amacıyla veri saklama
                            tedarikçilerimize aktarılabilir.
                        </p>

                        <h4>
                            İLETİŞİM VE PAZARLAMA SÜREÇLERİ
                        </h4>

                        <p className={'text-brand-color'}>Talep-Şikayet Takibi ve İletişim</p>

                        <p>
                            Pembe Panjur iletişim kanalları üzerinden bize bildirdiğiniz konu, talep ve şikayetler,
                            kimlik
                            ve iletişim bilgileriniz ile birlikte;
                        </p>

                        <ul>
                            <li>
                                Hizmet satış sonrası destek hizmetlerinin yürütülmesi, talep / şikayetlerin takibi ve
                                saklama ve arşiv faaliyetlerinin yürütülmesi amaçlarıyla
                            </li>
                            <li>
                            <span style={{fontWeight: 'bold'}}>KVKK Md.5/2e'deki bir hakkın tesisi kullanılması veya
                                korunması için veri işlemenin zorunlu olması ile KVKK Md.5/2f'deki ilgili kişinin temel
                                hak ve özgürlüklerine zarar vermemek kaydıyla veri sorumlusunun meşru menfaatleri için
                                veri işlemenin zorunlu olması sebepleriyle işlenmektedir.</span>
                            </li>
                        </ul>

                        <p className={'text-brand-color'}>Çağrı Merkezi</p>

                        <p>
                            Pembe Panjur çağrı merkezi ile iletişime geçmeniz halinde işlenen ad, soyad, telefon
                            numarası ve
                            ses kaydı bilgileriniz; iletişim faaliyetlerinin, satış sonrası destek süreçlerinin, müşteri
                            ilişkileri yönetim süreçlerinin, saklama ve arşiv faaliyetlerinin yürütülmesi ve talep /
                            şikayetlerin takibi amaçlarıyla, KVKK’nın 5. maddesinde öngörülen, bir hakkın tesisi,
                            kullanılması veya korunması için veri işlemenin zorunlu olması ve ilgili kişinin temel hak
                            ve
                            özgürlüklerine zarar vermemek kaydıyla, veri sorumlusunun meşru menfaatleri için veri
                            işlenmesinin zorunlu olması sebepleriyle işlenmektedir.
                        </p>

                        <p className={'text-brand-color'}>Whatsapp İletişimi</p>

                        <p>
                            Pembe Panjur ile Whatsapp üzerinden iletişime geçmek isterseniz kimlik ve iletişim
                            bilgileriniz,
                            iletişim faaliyetlerinin yürütülmesi amacıyla işlenir. Whatsapp verilerinin yurt dışında
                            bulunması sebebiyle kişisel verileriniz yalnızca KVKK Md.9/1'de düzenlenen yurt dışına
                            kişisel
                            verilerin aktarılmasına ilişkin açık rızanızın bulunması durumunda işlenir ve Whatsapp
                            LLC’ye
                            aktarılır.
                        </p>

                        <p className={'text-brand-color'}>Pazarlama Süreçleri</p>

                        <p>
                            Pembe Panjur’dan ticari elektronik ileti almak, kampanya ve promosyonlar hakkında bilgi
                            almak,
                            size özel fırsatlardan haberdar olmak istemeniz halinde kimlik, e-posta adresi, telefon
                            numarası, iletişim kanalı ve iletişim izni bilgileriniz; reklam/kampanya süreçlerinin,
                            iletişim
                            faaliyetlerinin, ürün ve hizmetlerin pazarlama süreçlerinin, pazarlama analiz çalışmalarının
                            ve
                            saklama faaliyetlerinin yürütülmesi amaçlarıyla, KVKK Md5/1’de öngörülen açık rızanıza
                            istinaden
                            işlenmektedir. Bu kapsamda verdiğiniz açık rıza, 6563 sayılı Kanun kapsamında ticari
                            elektronik
                            ileti alımına ilişkin bir onayı içerir. Verdiğiniz açık rızayı her zaman geri alabilirsiniz.
                        </p>

                        <p>
                            İletişim onayı vermeniz takdirde bu onaya ilişkin kimlik, iletişim ve onay bilgileriniz
                            faaliyetlerin mevzuata uygun yürütülmesi amacıyla KVKK Md.5/2ç'deki veri sorumlusunun hukuki
                            yükümlülüğünü yerine getirebilmesi için zorunlu olması sebebiyle Ticari İletişim ve Ticari
                            Elektronik İletiler Hakkında Yönetmelik Md.7’ye istinaden İYS aracılığıyla Ticaret
                            Bakanlığına
                            bildirilmektedir.
                        </p>

                        <p>
                            Daha önce verdiğiniz iletişim onaylarını <Link href={'https://iys.org.tr'}
                                                                           target={'_blank'} style={{color: '#000'}}>iys.org.tr</Link> adresinden
                            veya <Link href={'/'} style={{color: '#000'}}>Pembe Panjur.com</Link> üyesiyseniz profilinizden yönetebilirsiniz.
                        </p>

                        <h3 style={{marginTop: 0}}>
                            Kişisel Verilerin Elde Edilme Yöntemleri
                        </h3>

                        <p>
                            <span style={{fontWeight: 'bold'}}>Kişisel verileriniz</span> <Link href={'/'} style={{color: '#000'}}>Pembe Panjur.com</Link>
                            <span style={{fontWeight: 'bold'}}> web sitesi ve Pembe Panjur mobil uygulaması üzerinden
                        dijital ortamlarda otomatik ya da kısmen otomatik yöntemlerle elde edilmektedir. Fiziki olarak
                        ilettiğiniz belgeler otomatik olmayan yöntemlerle elde edilmektedir. Bu elde etme işlemleri, web
                        sitesine girmeniz, formları doldurmanız ya da fiziki evrakları posta veya sair yöntemlerle bize
                        iletmeniz gibi yöntemlerle gerçekleşir.</span>
                        </p>

                        <p><span style={{fontWeight: 'bold'}}>
                        Otomatik veri işleme, bilgisayar, telefon gibi işlemci sahibi cihazlar tarafından yerine
                        getirilen, yazılım veya donanım özellikleri aracılığıyla önceden hazırlanan algoritmalar
                        kapsamında insan müdahalesi olmadan kendiliğinden gerçekleşen işleme faaliyetidir. Kısmen
                        otomatik veri işleme ise insan etkisi bulunan ancak yine bilgisayar gibi işlemci sahibi cihazlar
                        vasıtası ile kişisel veri işleme faaliyetidir. Otomatik olmayan yöntemlerle işlenen kişisel
                        verilerinizden yalnızca bir veri kayıt sisteminin parçası olanlar Kanun kapsamında kişisel veri
                        işleme olarak değerlendirilir.</span>
                        </p>

                        <h3 style={{marginTop: 0}}>
                            Kişisel Verilerinizle İlgili Haklarınız
                        </h3>

                        <p>
                            Veri sorumlusu olarak, Kanun kapsamında kişisel verilerinizin işlenmesi ile ilgili bize
                            başvurarak kullanabileceğiniz haklarınız bulunmaktadır. Bu kapsamda,
                        </p>

                        <ul>
                            <li>
                                Kişisel verilerinizin işlenip işlenmediğini öğrenme,
                            </li>
                            <li>
                                Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,
                            </li>
                            <li>
                                Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp
                                kullanılmadığını
                                öğrenme,
                            </li>
                            <li>
                                Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,
                            </li>
                            <li>
                                Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini
                                isteme,
                            </li>
                            <li>
                                İşlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerinizin
                                silinmesini
                                veya yok edilmesini isteme,
                            </li>
                            <li>
                                Düzeltme ve silme işlemlerinin, kişisel verilerinizin aktarıldığı üçüncü kişilere
                                bildirilmesini isteme,
                            </li>
                            <li>
                                İşlenen verilerinizin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi
                                suretiyle
                                aleyhinize bir sonucun ortaya çıkmasına itiraz etme,
                            </li>
                            <li>
                                Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde
                                zararın giderilmesini talep etme
                            </li>
                        </ul>

                        <p>
                            Haklarınızı, aşağıda belirtilen yöntemlerle bize başvurarak kullanabilirsiniz.
                        </p>
                        <p>
                            Kişisel verilerinizin işlenmesine ilişkin haklarınızı kullanabilmeniz için öncelikle veri
                            sorumlusuna başvurmanız gerekmektedir. Başvurunun reddedilmesi, verilen cevabın yetersiz
                            bulunması veya süresinde başvuruya cevap verilmemesi hâllerinde; cevabı öğrendiğiniz
                            tarihten
                            itibaren otuz ve her hâlde başvuru tarihinden itibaren altmış gün içinde Kurula şikâyette
                            bulunabilirsiniz.
                        </p>

                        <h3 style={{marginTop: 0}}>
                            Veri Sorumlusuna Başvuru Yöntemi
                        </h3>

                        <p>
                            Başvurunuzu
                        </p>
                        <ul>
                            <li>
                                Yeşilköy Mah. Atatürk Cad. No: 12/2 EGS Business Park B3 Blok Ofis 264 Bakırköy,
                                İstanbul
                                adresine yazılı olarak;
                            </li>
                            <li>
                                Kayıtlı Elektronik Posta (KEP) adresinizi kullanarak <a
                                href="mailto:panjur.bilisim@hs02.kep.tr"
                                style={{color: '#000'}}>panjur.bilisim@hs02.kep.tr</a> KEP
                                adresine;
                            </li>
                            <li>
                                Veya sistemlerimizde size ait görünen e-posta adresinizi kullanarak <a
                                href="mailto:kvk@pembepanjur.com"
                                style={{color: '#000'}}> kvk@pembepanjur.com
                            </a> adresine e-posta göndererek gerçekleştirebilirsiniz.
                            </li>
                        </ul>

                        <p>
                            Başvurunuzda;
                        </p>

                        <ul>
                            <li>
                                Adınızın, soyadınızın ve başvuru yazılı ise imzanızın,
                            </li>
                            <li>
                                Türkiye Cumhuriyeti vatandaşları için T.C. kimlik numaranızın, yabancı iseniz
                                uyruğunuzun,
                                pasaport numaranızın veya varsa kimlik numaranızın,
                            </li>
                            <li>
                                Tebligata esas yerleşim yeri veya iş yeri adresinizin,
                            </li>
                            <li>
                                Varsa bildirime esas elektronik posta adresi, telefon ve faks numaranızın,
                            </li>
                            <li>
                                Talep konunuzun bulunması zorunlu olup varsa konuya ilişkin bilgi ve belgelerin de
                                başvuruya
                                eklenmesi gerekmektedir.
                            </li>
                        </ul>

                        <p>
                            Başvurunuz otuz gün içinde sonuçlandırılarak (i) Kabul edilip talebiniz ile ilgili
                            tarafınıza
                            bilgi verilebilir veya (ii) Gerekçesi açıklanarak reddedilebilir.
                        </p>

                        <p>
                            Başvuru yapılırken uyulması gereken usul ve esaslar hakkındaki daha detaylı bilgiye Kişisel
                            Verileri Koruma Kurumu'nun Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ" ile
                            ulaşabilirsiniz.
                        </p>
                    </TextArea>
                </ProtectionOfPersonalDataWrapper>
            </WaveLayout>
        </React.Fragment>
    );
}

const ProtectionOfPersonalDataWrapper = styled.div`
  position: relative;
  padding: 0 25px;
  margin-bottom: 44px;

  @media ${deviceMax.tablet} {
    padding: 70px 0 0 0;
    margin-bottom: 0;
  }

  > div {
    padding-left: 40px;
    padding-right: 40px;
  }
  
  h2 {
    margin-top: 0;
    text-transform: uppercase;
    color: ${Colors.brandColor};

    @media ${deviceMax.tablet} {
      color: ${Colors.black};
      text-align: center;
      margin: 0 auto 24px;
    }
  }

  .listMarkerPink {
    font-weight: bold;
    color: ${Colors.brandColor};

    p, span {
      margin-left: -17px;
      color: ${Colors.black};
    }

    &::marker {
      font-weight: bold;
      color: ${Colors.brandColor};
    }

    > ul {
      > .ml-0 {
        > span {
          margin-left: 0;
        }
      }
    }
  }

  .listMarkerBold {
    &::marker {
      font-weight: bold;
    }
  }
`;

import { checkAuthAndRedirect } from '../src/utils/authHelper';
export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};

export default KisiselVerilerinKorunmasi;
